import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Topbar from "@/components/layout/Topbar";
import { StatusBadge } from "@/components/StatusBadge";
import { formatDate } from "@/lib/format";

export default function SuperSubscriptions() {
    const [subs, setSubs] = useState([]);
    const [hotels, setHotels] = useState([]);
    const [plans, setPlans] = useState([]);

    useEffect(() => {
        Promise.all([api.get("/billing/subscriptions"), api.get("/hotels"), api.get("/billing/plans")]).then(([s, h, p]) => {
            setSubs(s.data); setHotels(h.data); setPlans(p.data);
        });
    }, []);

    const hotelName = (id) => hotels.find((h) => h.id === id)?.name || "—";
    const planName = (id) => plans.find((p) => p.id === id)?.name || "—";

    return (
        <>
            <Topbar title="Subscriptions" subtitle={`${subs.length} subscriptions`} />
            <div className="flex-1 overflow-auto p-6">
                <div className="akm-card overflow-hidden">
                    <table className="akm-table w-full">
                        <thead className="bg-muted/40"><tr><th>Hotel</th><th>Plan</th><th>Status</th><th>Started</th></tr></thead>
                        <tbody>
                            {subs.map((s) => (
                                <tr key={s.id}>
                                    <td className="font-medium">{hotelName(s.hotel_id)}</td>
                                    <td>{planName(s.plan_id)}</td>
                                    <td><StatusBadge status={s.status} /></td>
                                    <td className="text-muted-foreground">{formatDate(s.started_at)}</td>
                                </tr>
                            ))}
                            {subs.length === 0 && <tr><td colSpan="4" className="py-12 text-center text-muted-foreground">No subscriptions</td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
